import { InteractionRequiredAuthError, PublicClientApplication, type SilentRequest } from "@azure/msal-browser";
import config from "@sg-protect/runtime-config";
import { Routes } from "../../constants.ts";

const requestScopes: string[] = ["openid", "profile"];

interface AuthenticationResult {
    idTokenClaims: IdTokenClaims;
    idToken: string;
}

interface IdTokenClaims {
    roles?: string[];
}

type SilentRequestOptions = Omit<SilentRequest, "scopes">;

export const msalInstance = new PublicClientApplication({
    auth: {
        clientId: config.get().app_registrations.migrate,
        authority: "https://login.microsoftonline.com/organizations"
    },
    cache: {
        cacheLocation: "localStorage"
    }
});

let initializePromise: Promise<void> | null = null;

export function initializeMsal(): Promise<void> {
    if (!initializePromise) {
        initializePromise = msalInstance.initialize();
    }

    return initializePromise;
}

export const acquireMsalToken = async (request: SilentRequestOptions = {}): Promise<AuthenticationResult> => {
    await initializeMsal();

    try {
        return await msalInstance.acquireTokenSilent({ scopes: requestScopes, ...request });
    } catch (error) {
        if (error instanceof InteractionRequiredAuthError) {
            // https://learn.microsoft.com/en-us/entra/identity-platform/msal-error-handling-js
            const baseUrl = window.location.origin;
            const redirectUri = `${baseUrl}${Routes.microsoft.wizard}`;

            await msalInstance.acquireTokenRedirect({
                scopes: requestScopes,
                redirectUri,
                ...request
            });
        }
        throw error;
    }
};

export const msalTokenHasAssessorRole = async () => {
    const token = await acquireMsalToken();

    return Array.isArray(token.idTokenClaims?.roles) && token.idTokenClaims.roles.includes("Assessor");
};
